module.exports = __webpack_public_path__ + "assets/file.png";